import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeMap = {
  sm: 16,
  md: 24,
  lg: 36,
  xl: 48,
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <Loader2
      size={sizeMap[size]}
      className={cn('animate-spin text-lumina-700 dark:text-lumina-300', className)}
    />
  )
}

export function FullPageSpinner() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 dark:bg-surface-900/80 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center gap-3">
        <Spinner size="lg" />
        <p className="text-sm font-medium text-surface-500 animate-pulse-soft">Loading…</p>
      </div>
    </div>
  )
}

export function PageSpinner() {
  return (
    <div className="flex-1 flex items-center justify-center min-h-[40vh]">
      <Spinner size="lg" />
    </div>
  )
}

export function InlineSpinner({ className }: { className?: string }) {
  return <Spinner size="sm" className={className} />
}

// Skeleton loader
interface SkeletonProps {
  className?: string
  rounded?: 'sm' | 'md' | 'lg' | 'full'
}

export function Skeleton({ className, rounded = 'md' }: SkeletonProps) {
  const r = { sm: 'rounded', md: 'rounded-lg', lg: 'rounded-xl', full: 'rounded-full' }[rounded]
  return (
    <div
      className={cn(
        'bg-surface-200 dark:bg-surface-700 animate-pulse',
        r,
        className,
      )}
    />
  )
}
